var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup290(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.179,
    height: 50.498,
    viewBox: "0 0 66.179 50.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(-1701 -487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(1701 487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "flaky_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M103.946-832.108a23.317,23.317,0,0,1-9.339-1.886,24.184,24.184,0,0,1-7.6-5.118,24.182,24.182,0,0,1-5.118-7.6A23.317,23.317,0,0,1,80-856.054a23.318,23.318,0,0,1,1.886-9.339A24.181,24.181,0,0,1,87-873a24.182,24.182,0,0,1,7.6-5.119A23.317,23.317,0,0,1,103.946-880a23.317,23.317,0,0,1,9.339,1.886,24.182,24.182,0,0,1,7.6,5.119,24.181,24.181,0,0,1,5.118,7.6,23.318,23.318,0,0,1,1.886,9.339,23.318,23.318,0,0,1-1.886,9.339,24.183,24.183,0,0,1-5.118,7.6,24.184,24.184,0,0,1-7.6,5.118A23.317,23.317,0,0,1,103.946-832.108Zm-7.783-29.214,2.1,2.155a1.723,1.723,0,0,0,1.257.539,1.723,1.723,0,0,0,1.257-.539,1.756,1.756,0,0,0,.539-1.287,1.757,1.757,0,0,0-.539-1.287l-2.1-2.1,2.155-2.1a1.723,1.723,0,0,0,.539-1.257,1.723,1.723,0,0,0-.539-1.257,1.756,1.756,0,0,0-1.287-.539,1.756,1.756,0,0,0-1.287.539l-2.1,2.1-2.1-2.155a1.723,1.723,0,0,0-1.257-.539,1.723,1.723,0,0,0-1.257.539,1.757,1.757,0,0,0-.539,1.287,1.757,1.757,0,0,0,.539,1.287l2.1,2.1-2.155,2.1a1.724,1.724,0,0,0-.539,1.257,1.723,1.723,0,0,0,.539,1.257,1.757,1.757,0,0,0,1.287.539,1.757,1.757,0,0,0,1.287-.539Zm7.783,24.425a18.467,18.467,0,0,0,13.56-5.6,18.467,18.467,0,0,0,5.6-13.559,18.552,18.552,0,0,0-1.5-7.423,19.425,19.425,0,0,0-4.131-6.106L90.417-842.524a19.423,19.423,0,0,0,6.106,4.131A18.55,18.55,0,0,0,103.946-836.9Zm4.909-10.836,4.729-4.669a1.963,1.963,0,0,1,1.257-.509,1.62,1.62,0,0,1,1.257.509,1.723,1.723,0,0,1,.539,1.257,1.723,1.723,0,0,1-.539,1.257l-5.567,5.567a2.3,2.3,0,0,1-1.676.719,2.3,2.3,0,0,1-1.676-.719l-2.814-2.814a1.723,1.723,0,0,1-.539-1.257,1.723,1.723,0,0,1,.539-1.257,1.757,1.757,0,0,1,1.287-.539,1.757,1.757,0,0,1,1.287.539Z",
    transform: "translate(-61.714 882.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 15.403,
    height: 30.805,
    transform: "translate(9.287 20.789) rotate(-47)",
    fill: "#1f2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M0,31.823v6.689a1.089,1.089,0,0,0,1.1,1.1H7.789a1.032,1.032,0,0,0,.77-.33L32.588,15.276,24.336,7.025.33,31.031a1.08,1.08,0,0,0-.33.792ZM38.969,8.9a2.191,2.191,0,0,0,0-3.1L33.82.644a2.191,2.191,0,0,0-3.1,0L26.691,4.67l8.251,8.251L38.969,8.9Z",
    transform: "matrix(-0.035, -0.999, 0.999, -0.035, 1.382, 40.971)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup290);
export default __webpack_public_path__ + "static/media/Group 290.245f6032031b875be01aac22d61f3c5c.svg";
export { ForwardRef as ReactComponent };